import { Link } from 'react-router-dom';
import { posts } from '@/mocks/community';

export default function LatestPosts() {
  return (
    <section className="mx-auto w-full max-w-7xl px-4 md:px-6 py-14 md:py-20">
      <div className="flex items-end justify-between gap-4">
        <div>
          <span className="text-xs font-semibold tracking-widest text-primary-600">LATEST POSTS</span>
          <h2 className="mt-1 font-heading text-2xl md:text-3xl">最新讨论帖</h2>
        </div>
        <Link
          to="/community"
          className="inline-flex whitespace-nowrap items-center gap-1 text-sm font-semibold text-primary-700 hover:text-primary-800"
        >
          全部帖子 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-2">
        {posts.map((p) => (
          <Link
            key={p.id}
            to={`/post/${p.id}`}
            className="group flex gap-4 rounded-2xl border border-background-200 bg-background-50 p-4 hover:border-primary-300 transition-colors"
          >
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-accent-100 text-accent-700 font-heading text-lg">
              {p.author.slice(0, 1)}
            </span>
            <div className="min-w-0 flex-1">
              <div className="flex flex-wrap items-center gap-2">
                <span className="text-xs font-medium text-primary-600">{p.board}</span>
                <span className="text-xs text-foreground-400">{p.time}</span>
                {p.pinned && (
                  <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-700">
                    <i className="ri-pushpin-fill mr-0.5"></i>置顶
                  </span>
                )}
              </div>
              <h3 className="mt-1.5 line-clamp-2 text-sm md:text-base font-semibold text-foreground-950 group-hover:text-primary-700 transition-colors">
                {p.title}
              </h3>
              <div className="mt-2 flex flex-wrap items-center gap-2">
                {p.tags.slice(0, 3).map((t) => (
                  <span key={t} className="rounded-md bg-background-100 px-2 py-0.5 text-[11px] text-foreground-600">
                    #{t}
                  </span>
                ))}
              </div>
              <div className="mt-3 flex items-center gap-4 text-xs text-foreground-500">
                <span>{p.author}</span>
                <span><i className="ri-chat-3-line mr-0.5"></i>{p.replies}</span>
                <span><i className="ri-eye-line mr-0.5"></i>{p.views.toLocaleString()}</span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}